import { LANDING_TEXTS, NAV_BAR_TEXTS } from './text.constants';

export interface FeatureItem {
  id: number;
  icon: string;
  title: string;
  subtitle: string;
}

export const FEATURES_ITEMS: FeatureItem[] = [
  {
    id: 1,
    icon: '/assets/icons/wand-sparkles.svg',
    title: LANDING_TEXTS.FEATURES_ITEMS.CUSTOM.TITLE,
    subtitle: LANDING_TEXTS.FEATURES_ITEMS.CUSTOM.DESCRIPTION,
  },
  {
    id: 2,
    icon: '/assets/icons/vegan.svg',
    title: LANDING_TEXTS.FEATURES_ITEMS.MATERIALS.TITLE,
    subtitle: LANDING_TEXTS.FEATURES_ITEMS.MATERIALS.DESCRIPTION,
  },
  {
    id: 3,
    icon: '/assets/icons/box.svg',
    title: LANDING_TEXTS.FEATURES_ITEMS.DESIGNS.TITLE,
    subtitle: LANDING_TEXTS.FEATURES_ITEMS.DESIGNS.DESCRIPTION,
  },
];

export const NAV_BAR_ITEMS = [
  { label: NAV_BAR_TEXTS.HOME, link: '/' },
  { label: NAV_BAR_TEXTS.CATALOG, link: '/catalogo' },
  { label: NAV_BAR_TEXTS.CUSTOM_ORDER, link: '/encargo' },
];
